let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '用户编号',
        props: 'userNo',
        minWidth: 300,
    },
    {
        label: '用户名',
        props: 'userName',
        minWidth: 200,
        tooltip:true,
    },
    {
        label: '手机号',
        props: 'userPhone',
        minWidth: 200,
    },
    {
        label: '邮箱',
        props: 'email',
        minWidth: 200,
    },
    {
        label: '角色',
        props: 'roleName',
        minWidth: 200,
    },
    {
        label: '创建时间',
        props: 'createdWhen',
        minWidth: 200,
    },
    {
        label: '最近修改时间',
        props: 'lastModifiedWhen',
        minWidth: 200,
    }
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '系统管理'
},
{
    type: 'title',
    name: '用户管理'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'userId',
    editRouter: 'userManageDetail',
};

// 路由
pageConfig.listRouter = 'user_list';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'router',
    name: '用户管理',
    router: 'user_list'
},
{
    type: 'title',
    name: '详情',
}];

pageConfig.formRules = {
    userName: [{
        required: true,
        message: '请填写用户名',
        trigger: 'blur'
    }],
    userPassword: [{
        required: true,
        message: '请设置密码',
        trigger: 'blur'
    }],
    describe: [{
        required: true,
        message: '请填写账号描述',
        trigger: 'blur'
    }],
    status: [{
        required: true,
        message: '请填写账号状态',
        trigger: 'blur'
    }],
    // dataCheck: [{
    //     required: true,
    //     message: '请选择账号归属',
    //     trigger: 'blur'
    // }],
    userPhone: [{
        required: true,
        message: '请填写手机号',
        trigger: 'blur'
    },
    {
        pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
        message: '手机号填写错误',
        trigger: 'blur'
    }],
    email: [{
        required: true,
        message: '请填写邮箱',
        trigger: 'blur'
    },
    {
        pattern: /^[a-zA-Z0-9_.-]+@[A-Za-z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
        message: '邮箱格式有误',
        trigger: 'blur'
    }],
    roleId: [{
        required: true,
        message: '请选择角色权限',
        trigger: 'change'
    }],
};



export default pageConfig;